import { Center, HStack, Spinner, VStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { getHistory } from "../../../../../../utils/api/history.api";
import {
  useHistoryDispatch,
  useHistoryState,
} from "../../../../../../utils/context/HistoryContext";
import { useUserInfo } from "../../../../../../utils/hooks/useUserInfo";
import { MessageHistory } from "../../../../../../utils/types";
import SlideRange from "../../../../../common/SlideRange";
import Export from "../Export";
import NoItem from "../NoItem";
import SingleMessageCard from "./SingleMessageCard";

type MessagesType = {
  setClickedRecord: Dispatch<SetStateAction<any>>;
  clickedRow: any;
};

function Messages({ setClickedRecord, clickedRow }: MessagesType) {
  const dealership = useUserInfo("dealership");
  const [messageActivities, setMessageActivities] = useState<MessageHistory[]>([]);
  const [sliderValue, setSliderValue] = useState("30");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const { shouldRefetch } = useHistoryState();
  const dispatch = useHistoryDispatch();

  const { isLoading, refetch, isFetching } = useQuery({
    queryKey: ["messageHistory", clickedRow?.id, sliderValue, page],
    queryFn: () =>
      getHistory({
        dealershipId: dealership?.id,
        contactId: clickedRow?.id,
        days: sliderValue,
        page,
        type:'Message'
      }),
    retry: false,
    onSuccess: (data) => {
      if (messageActivities[0]?.contact_id !== clickedRow?.id) {
        setMessageActivities(data.data.histories || []);
        setPage(1);
      } else {
        const filteredNewHistories = data?.data?.histories?.filter(
          (newHistory: any) =>
            !messageActivities?.some((existing) => existing.id === newHistory.id)
        );

        setMessageActivities((prev) => [...prev, ...filteredNewHistories]);
      }
      setTotalCount(data.data.histories_count);
    },
  });

  useEffect(() => {
    setPage(1);
    setMessageActivities([]);
    refetch();
  }, [clickedRow?.id, refetch, sliderValue]);

  useEffect(() => {
    if (shouldRefetch) {
      setPage(1);
      setMessageActivities([]);
      refetch();
    }

    dispatch({ type: "SET_SHOULD_REFETCH", payload: { shouldRefetch: false } });
  }, [dispatch, refetch, shouldRefetch]);

  return (
    <>
      {" "}
      <Export type="MessageHistory" days={sliderValue} id={clickedRow?.id} />
      <HStack background="var(--grey-200)" padding="1rem" w="100%">
        <SlideRange handleClick={(value) => setSliderValue(value)} />
      </HStack>{" "}
      {isFetching && page === 1 && (
        <Center w="100%" h="calc(100vh - 375px)">
          <Spinner />
        </Center>
      )}{" "}
      {!!messageActivities.length &&
      !!messageActivities.filter((item) => !!item.details).length ? (
        <div
          id="scrollableDivMessage"
          style={{ height: "calc(100vh - 375px)", overflow: "auto" }}
        >
          <InfiniteScroll
            dataLength={messageActivities.length}
            next={() => {
              setPage((prev) => prev + 1);
            }}
            hasMore={messageActivities.length < totalCount}
            loader={<h4>Loading...</h4>}
            scrollableTarget="scrollableDivMessage"
          >
            <VStack
              alignItems="flex-start"
              gap="1rem"
              padding="1rem"
              background="var(--grey-200)"
            >
              {messageActivities.map((item) => {
                return (
                  <SingleMessageCard
                    item={item}
                    setClickedRecord={setClickedRecord}
                  />
                );
              })}
            </VStack>
          </InfiniteScroll>
        </div>
      ) : (
        !isLoading && !isFetching && <NoItem />
      )}
    </>
  );
}

export default Messages;
